// extracted by mini-css-extract-plugin
export default {"title":"template-list-module__title--W0uLr","metadata":"template-list-module__metadata--R_oOs"};